import React from 'react';
import { Link } from 'react-router-dom';

function Privacy() {
  return (
    <>
      <nav className="flex justify-between items-center px-6 py-4 bg-white shadow-sm fixed top-0 w-full z-50">
        <div className="text-xl font-bold text-primary">
          <Link to="/" className="text-primary no-underline">Remote Assistant</Link>
        </div>
        <div className="flex items-center gap-6">
          <Link to="/" className="text-gray-700 hover:text-primary no-underline">Home</Link>
          <Link to="/signup" className="px-6 py-3 rounded-xl bg-primary hover:bg-primary-hover text-white font-semibold shadow no-underline">
            Get Started
          </Link>
        </div>
      </nav>

      <section className="pt-24 pb-16 px-8 max-w-4xl mx-auto">
        <div className="bg-white p-12 rounded-2xl shadow-sm border">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 text-center">Privacy Policy</h1>
          <p className="text-center text-gray-600 mb-12">
            <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
          </p>
          
          <div className="space-y-8">
            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">1. Information We Collect</h2>
              <p className="text-gray-700 leading-relaxed">
                We collect information you provide directly, such as account details, calendar data, and communication preferences when you authorize access to third-party services.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">2. How We Use Your Information</h2>
              <p className="text-gray-700 leading-relaxed">
                We use your information to provide AI assistant services, manage appointments, process payments, and improve our service quality.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">3. Information Sharing</h2>
              <p className="text-gray-700 leading-relaxed">
                We do not sell your personal information. We may share data with service providers necessary for operations and as required by law.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">4. Data Security</h2>
              <p className="text-gray-700 leading-relaxed">
                We implement industry-standard security measures to protect your information, though no system is 100% secure.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">5. Your Rights</h2>
              <p className="text-gray-700 leading-relaxed">
                You may access, update, or delete your personal information by contacting us. You can revoke third-party service authorizations at any time.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">6. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                Our liability is limited to the maximum extent permitted by law. We provide services "as is" without warranties.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">7. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed">
                For privacy questions, contact us at <a href="mailto:privacy@remote-assistant.ai" className="text-primary hover:underline">privacy@remote-assistant.ai</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Privacy;